import React from 'react';

/* Cost bars, all scaled against the largest value present, with the net price
   highlighted — it is the only figure a family actually pays.
   Ported from `CostLadder` in MatchDetailSheet.swift.

   Every bar carries its label and dollar value as text, so the chart is
   readable without color and the value is never encoded by length alone. */

export default function CostLadder({ bars }) {
  const shown = bars.filter((b) => b.value != null);
  if (shown.length === 0) return null;
  const maxValue = Math.max(...shown.map((b) => b.value));

  return (
    <div className="sd-chart">
      {shown.map((bar) => {
        // The 2px floor keeps a small-but-real value from rendering as nothing.
        const frac = maxValue > 0 ? bar.value / maxValue : 0;
        const width = `max(2px, ${(frac * 100).toFixed(2)}%)`;
        const dollars = `$${Number(bar.value).toLocaleString()}`;
        return (
          <div
            key={bar.label}
            className={`sd-ladder__bar${bar.highlighted ? ' sd-ladder__bar--hi' : ''}`}
          >
            <div className="sd-ladder__head">
              <span className="sd-ladder__label">{bar.label}</span>
              <span className="sd-ladder__value">{dollars}</span>
            </div>
            <div className="sd-track" role="img" aria-label={`${bar.label}: ${dollars}`}>
              <div className="sd-track__fill" style={{ width }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
